import { Component, OnInit, Input, Output, EventEmitter, SimpleChange } from '@angular/core';
import { CambioPiano } from '../../../models/fisso';
import { textField, textFieldVulnerabili } from './change-plan-conditions-subscriptions';
import { FileUploader } from 'ng2-file-upload/ng2-file-upload';
import { environment } from '../../../../environments/environment';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { AlgConsensoService } from '../../../services/alg-consenso.service';
import { Sex } from '../../../models/onboarding';
import { VulnerabilityType } from '../../../models/product';

@Component({
  selector: 'alg-change-plan-conditions-subscription',
  templateUrl: './alg-change-plan-conditions-subscription.component.html',
  styleUrls: ['./alg-change-plan-conditions-subscription.component.scss'],
})
export class AlgChangePlanConditionsSubscriptionComponent implements OnInit {
  @Output() checkboxOutput104Consent = new EventEmitter<boolean>();
  @Input() invalid104Condition: boolean;
  @Input() changePlan: CambioPiano;
  @Input() isProductGasVulnerable: boolean;
  @Input() isGenericVulnerable: boolean;

  public textField = textField;
  public textFieldVulnerabili = textFieldVulnerabili;
  public uploaderFront: FileUploader;
  public uploaderBack: FileUploader;
  public contractForm: FormGroup;
  public controlCheckboxConsent: boolean;
  public docsReceptionCheckboxConsent: boolean;
  public generalConditionCheckboxConsent: boolean;
  public supplyStartCheckboxConsent: boolean;
  public uploadedDocumentFront: boolean;
  public uploadedDocumentBack: boolean;
  public fileFormatErrorFront: boolean;
  public fileFormatErrorBack: boolean;
  public fileUploadErrorFront: boolean;
  public fileUploadErrorBack: boolean;
  public overDropFront: boolean;
  public overDropBack: boolean;
  public isVulnerabilityTypeDisability: boolean;
  public vulnerabilityType: VulnerabilityType;
  public gender: Sex;
  public isPlacet: boolean;
  public readAcceptance = {
    consentCondition: false,
    docsReceptionCondition: false,
    supplyStartCondition: false,
    generalCondition: false,
  };
  public productName: string;

  constructor(private consensoService: AlgConsensoService) {
    this.consensoService.isVulnerabilityTypeDisability$.subscribe((value) => {
      this.isVulnerabilityTypeDisability = value;
      if (value) {
        this.readAcceptance.consentCondition = true;
        // TODO: cosa fare in caso di vulnerabilità disability
      }
    });
    this.consensoService.vulnerabilityType$.subscribe((value) => {
      this.vulnerabilityType = value;
    });
  }

  ngOnInit() {
    const URL = `${environment.api.basePath}/upload-changeplan-document/${this.changePlan.requestId}`;

    // Uploader Front configuration
    this.uploaderFront = new FileUploader({
      url: URL,
      autoUpload: true,
      disableMultipart: false,
      itemAlias: 'changePlanDocument104Front',
    });
    // Rename file
    this.uploaderFront.onAfterAddingFile = (file) => {
      const timestamp = new Date().getTime();
      file.file.name = `${this.changePlan.requestId}_${timestamp}`;
    };
    this.uploaderFront.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    // Check file upload status
    this.uploaderFront.onSuccessItem = (status) => {
      if (status.isSuccess) {
        this.uploadedDocumentFront = true;
        this.consensoService.uploaded104DocumentFront$.next(true);
      }
      if (status.isError) {
        this.fileUploadErrorFront = true;
        this.consensoService.uploaded104DocumentFront$.next(false);
      }
    };

    this.uploaderFront.onErrorItem = (status) => {
      if (status.isError) {
        this.fileUploadErrorFront = true;
        this.consensoService.uploaded104DocumentFront$.next(false);
      }
    };

    // Uploader Back configuration
    this.uploaderBack = new FileUploader({
      url: URL,
      disableMultipart: false,
      autoUpload: true,
      itemAlias: 'changePlanDocument104Back',
    });
    this.uploaderBack.onBeforeUploadItem = (item) => {
      item.withCredentials = false;
    };
    // Rename file
    this.uploaderBack.onAfterAddingFile = (file) => {
      const timestamp = new Date().getTime();
      file.file.name = `${this.changePlan.requestId}_${timestamp}`;
    };
    // Check file upload status
    this.uploaderBack.onSuccessItem = (status) => {
      if (status.isSuccess) {
        this.uploadedDocumentBack = true;
        this.consensoService.uploaded104DocumentBack$.next(true);
      }
      if (status.isError) {
        this.fileUploadErrorBack = true;
        this.consensoService.uploaded104DocumentBack$.next(false);
      }
    };
    this.uploaderBack.onErrorItem = (status) => {
      if (status.isError) {
        this.fileUploadErrorBack = true;
        this.consensoService.uploaded104DocumentBack$.next(false);
      }
    };

    this.contractForm = new FormGroup({
      consentCondition: new FormControl(this.readAcceptance.consentCondition, {
        validators: [Validators.requiredTrue],
      }),
      docsReceptionCondition: new FormControl(this.readAcceptance.docsReceptionCondition, {
        validators: [Validators.requiredTrue],
      }),
      supplyStartCondition: new FormControl(this.readAcceptance.supplyStartCondition, {
        validators: [Validators.requiredTrue],
      }),
      generalCondition: new FormControl(this.readAcceptance.generalCondition, {
        validators: [Validators.requiredTrue],
      }),
    });

    this.contractForm.valueChanges.subscribe((data) => {
      this.readAcceptance.consentCondition = data.consentCondition;
      this.readAcceptance.docsReceptionCondition = data.docsReceptionCondition;
      this.readAcceptance.supplyStartCondition = data.supplyStartCondition;
      this.readAcceptance.generalCondition = data.generalCondition;
    });
    this.productName = this.changePlan.NewProductName;
    console.log('productName', this.productName);
    this.isPlacet = this.productName && this.productName.toLowerCase() === 'placet';
  }

  ngOnChanges() {
    this.calculateSexfromCF(this.changePlan.fiscalCode);
  }
  public calculateSexfromCF(cf: string) {
    if (!cf) return;
    const fiscalCode = cf;
    let numberOfGender: number;
    numberOfGender = parseInt(fiscalCode.substring(9, 11));
    numberOfGender > 31 ? (this.gender = Sex.female) : (this.gender = Sex.male);
  }

  public changeCheckbox(type) {
    switch (type) {
      case 'consent':
        this.checkboxOutput104Consent.emit(this.readAcceptance.consentCondition);
        this.consensoService.checkbox104Checked$.next(this.readAcceptance.consentCondition);
        break;
      case 'docsReception':
        this.consensoService.checkboxDocsReception$.next(this.readAcceptance.docsReceptionCondition);
        this.docsReceptionCheckboxConsent = !this.readAcceptance.docsReceptionCondition;

        break;
      case 'supplyStart':
        this.consensoService.checkboxSupplyStart$.next(this.readAcceptance.supplyStartCondition);
        this.supplyStartCheckboxConsent = !this.readAcceptance.supplyStartCondition;
        break;
      case 'generalCondition':
        this.consensoService.checkboxGeneralCondition$.next(this.readAcceptance.generalCondition);
        this.generalConditionCheckboxConsent = !this.readAcceptance.generalCondition;
        break;
    }
  }

  public droppedFile(event, type: string) {
    switch (type) {
      case 'front':
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.fileFormatErrorFront = false;
        } else {
          this.fileFormatErrorFront = true;
        }
        break;

      case 'back':
        if (event[0].type === 'image/png' || event[0].type === 'image/jpeg' || event[0].type === 'image/jpg' || event[0].type === 'application/pdf') {
          this.fileFormatErrorBack = false;
        } else {
          this.fileFormatErrorBack = true;
        }
        break;
    }
  }

  public fileOverBase(event, type: string) {
    switch (type) {
      case 'front':
        this.overDropFront = event;
        break;
      case 'back':
        this.overDropBack = event;
    }
  }

  public uploadDocument(type: string) {
    switch (type) {
      case 'front':
        (<HTMLInputElement>document.getElementById('frontDocument')).click();
        break;

      case 'back':
        (<HTMLInputElement>document.getElementById('backDocument')).click();
        break;
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/components/alg-change-plan/alg-change-plan-conditions-subscription/alg-change-plan-conditions-subscription.component.ts